import React from 'react';
import { X, Megaphone } from 'lucide-react';

const VendorBroadcastModal = ({ isOpen, onClose, notification }) => {
  if (!isOpen) return null;

  const title = notification?.title || 'Broadcast';
  const message = notification?.message || '';
  const createdAt = notification?.created_at
    ? new Date(notification.created_at).toLocaleString('en-US', {
        dateStyle: 'medium',
        timeStyle: 'short',
      })
    : '';

  return (
    <div className="fixed inset-0 z-[10002] overflow-y-auto">
      <div
        className="fixed inset-0 bg-black/50 transition-opacity"
        onClick={onClose}
        aria-hidden="true"
      />
      <div className="flex min-h-full items-center justify-center p-4">
        <div
          className="relative bg-white rounded-xl shadow-xl max-w-lg w-full mx-auto"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="p-6">
            <div className="flex items-start justify-between gap-4 mb-4">
              <div className="flex items-center gap-3">
                <div className="flex-shrink-0 w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center">
                  <Megaphone className="w-6 h-6 text-primary-600" />
                </div>
                <div>
                  <span className="inline-block px-2.5 py-0.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-1">
                    Broadcast from Admin
                  </span>
                  <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
                  {createdAt && (
                    <p className="text-xs text-gray-500 mt-0.5">{createdAt}</p>
                  )}
                </div>
              </div>
              <button
                onClick={onClose}
                className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
                aria-label="Close"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="border-t border-gray-200 pt-4">
              <p className="text-sm text-gray-700 whitespace-pre-wrap leading-relaxed">
                {message}
              </p>
            </div>
            <div className="mt-6 flex justify-end">
              <button
                onClick={onClose}
                className="px-4 py-2 text-sm font-medium text-white bg-gray-900 rounded-lg hover:bg-gray-800 transition-colors"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorBroadcastModal;
